// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1jOsL","image":"App_image__1JpY2"};